// Standalone snackbar service for use in non-React contexts (utility functions, etc.)
// This service works by dispatching custom events that the SnackbarContext listens to

class SnackbarService {
  showSnackbar(message, severity = 'info', autoHideDuration = 5000) {
    const event = new CustomEvent('show-snackbar', {
      detail: { message, severity, autoHideDuration }
    });
    window.dispatchEvent(event);
  }

  success(message, autoHideDuration = 5000) {
    this.showSnackbar(message, 'success', autoHideDuration);
  }

  error(message, autoHideDuration = 5000) {
    this.showSnackbar(message, 'error', autoHideDuration);
  }

  info(message, autoHideDuration = 5000) {
    this.showSnackbar(message, 'info', autoHideDuration);
  }

  warning(message, autoHideDuration = 5000) {
    this.showSnackbar(message, 'warning', autoHideDuration);
  }
}

export default new SnackbarService();
